'use strict';

import $ from 'jquery';
import 'select2';
import { recaptchaUpdater } from '../../modules/recaptcha';

const state = {
  settings: {
    $selectState: $('.js-state-filter'),
    $selectCity: $('.js-cities'),
    $selectVp: $('.js-vicepresident'),
    $selectSuper: $('.js-superintendent'),
    $selectRegional: $('.js-regional'),
  },
  init() {
    recaptchaUpdater('profile');

    s.$selectState.select2({ theme: 'classic' }).on('change', function(e) {
      var post = {};
      post.id = e.target.value;
      post._token = $('meta[name="csrf-token"]').attr('content');

      var url = '/estados/busca-cidades/' + post.id;

      $.ajax({
        type: 'GET',
        url: url,
        data: post,
        cache: false,
        dataType: 'json',
      }).then(function(data) {
        s.$selectCity.empty();

        $.each(data, function(index, element) {
          var option = new Option(element, index);
          s.$selectCity.append(option);
        });
      });
    });

    s.$selectCity.select2({
      placeholder: 'Primeiro selecione seu estado',
      theme: 'classic',
      sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
    });
  },
};

const _this = state,
  s = _this.settings;

export default _this;
